<div #scrollAreaContainer class="scroll-area" [style]="'text-align: ' + alignContent">
  <ng-content></ng-content>
</div>
